/**
 * De status van een doel van een deelnemer (`PersonaGoals.Status`) en hoe die
 * op het scherm heet.
 *
 * Nodig omdat de doelenkaart op het deelnemerdashboard en de Doelen-widget in
 * de rapportage dezelfde labels moeten tonen; de tabel stond alleen in
 * GoalsCard. De selects in Goals.jsx en PersonaGoalDetail.jsx hebben dezelfde
 * twee opties als losse `<option>`s.
 */

/** @type {Readonly<Object<string, string>>} */
export const GOAL_STATUS_LABEL = Object.freeze({
    'bereikt': 'Bereikt',
    'niet-bereikt': 'Niet bereikt',
})

/**
 * @param {{Status?: string}} [goal]
 * @returns {string} De status; zonder Status 'niet-bereikt', zoals de selects hem tonen
 */
export const goalStatus = (goal) => goal?.Status || 'niet-bereikt'

/**
 * @param {{Status?: string}} [goal]
 * @returns {string} Het label; een onbekende status zoals hij is opgeslagen
 */
export const goalStatusLabel = (goal) => {
    const status = goalStatus(goal)
    return GOAL_STATUS_LABEL[status] || status
}

const personaGoalStatus = { GOAL_STATUS_LABEL, goalStatus, goalStatusLabel }

export default personaGoalStatus
